import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/CashLimitUploadOutcomeRow.css';
import useDetailHandler from '../../hooks/useDetailHandler';
import {
    createUserValue,
    onActionKey,
} from '../../utils';
import { cashLimitUploadEventType } from '../../types';
import DateTime, {
    LONG_DATETIME,
} from '../DateTime';
import {
    getAllUploadOutcomes,
    getCashLimitUploadOutcome,
} from '../../utils/CashLimitUploadOutcome';
import CashLimitUploadEventDetailTab from './CashLimitUploadEventDetailTab';

export const getValueMapping = (t) => ({
    outcome: getAllUploadOutcomes().map((uploadOutcome) => ({
        from: uploadOutcome.outcome,
        to: uploadOutcome.translate(t),
    })),
});

CashLimitUploadEventRow.propTypes = {
    cashLimitUploadEvent: cashLimitUploadEventType.isRequired,
};

function CashLimitUploadEventRow(props) {
    const {
        cashLimitUploadEvent,
    } = props;
    const { t } = useTranslation();
    const { isDetailVisible, toggleDetail } = useDetailHandler(cashLimitUploadEvent.id);
    return (
        <>
            <div className="rich-list-row cash-limit-upload-event-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="cash-limit-upload-event-header--values--timestamp"><DateTime value={cashLimitUploadEvent.uploadTimestamp} format={LONG_DATETIME} /></div>
                <div className="cash-limit-upload-event-header--values--filename">{cashLimitUploadEvent.fileName}</div>
                <div className="cash-limit-upload-event-header--values--export-timestamp"><DateTime value={cashLimitUploadEvent.exportTimestamp} format={LONG_DATETIME} /></div>
                <div className="cash-limit-upload-event-header--values--uploader">{createUserValue(cashLimitUploadEvent.uploader, false)}</div>
                <div className="cash-limit-upload-event-header--values--outcome">{getCashLimitUploadOutcome(cashLimitUploadEvent.outcome).translate(t)}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <CashLimitUploadEventDetailTab
                    cashLimitUploadEvent={cashLimitUploadEvent}
                />
            )}
        </>
    );
}

export default CashLimitUploadEventRow;
